import { ApiErrorResponseFromJSON } from '@ibe/api';
import { DealFinderPaxConfiguration, OfferSettings } from '../Models/CMS/CmsDealFinderGlobalConfig';
import { action, computed, makeObservable, observable } from 'mobx';
import { removeTrailingSlashes } from '@ibe/services';
import i18next from 'i18next';

class CmsDealFinderGlobalConfigService {
  private _apiUrl: string;

  public _paxConfigurations: DealFinderPaxConfiguration[] = [];

  public _offerSettings: OfferSettings[] = [];

  private readonly loadConfigUrl = '/cms/dealFinder/config';

  private readonly loadOffersDataUrl = '/cms/dealFinder/offersData';

  constructor() {
    makeObservable(this, {
      _paxConfigurations: observable,
      _offerSettings: observable,
      paxConfigurations: computed,
      offerSettings: computed,
      fetchPaxConfigurations: action,
      fetchOffersData: action
    });
  }

  get paxConfigurations(): DealFinderPaxConfiguration[] {
    return this._paxConfigurations.length ? this._paxConfigurations : [];
  }

  get offerSettings(): OfferSettings[] {
    return this._offerSettings.length ? this._offerSettings : [];
  }

  set apiUrl(value: string) {
    this._apiUrl = removeTrailingSlashes(value);
  }

  async fetchPaxConfigurations(): Promise<DealFinderPaxConfiguration[]> {
    try {
      const response = await fetch(this._apiUrl + this.loadConfigUrl);
      const jsonResponse = await response.json();
      Object.assign(this._paxConfigurations, jsonResponse);
      return this._paxConfigurations;
    } catch (e) {
      this._paxConfigurations = [];
      throw ApiErrorResponseFromJSON(e);
    }
  }

  async fetchOffersData(startDate: string, endDate: string): Promise<OfferSettings[]> {
    try {
      const response = await this.fetchLocalized(
        this._apiUrl + this.loadOffersDataUrl + '?startDate=' + startDate + '&endDate=' + endDate
      );
      if (response && response.status !== 204) {
        const rawData = await response.json();
        this._offerSettings = rawData.map(OfferSettings.fromRaw);
      } else {
        this._offerSettings = [];
      }
      return this._offerSettings;
    } catch (e) {
      this._offerSettings = [];
      throw ApiErrorResponseFromJSON(e);
    }
  }

  private readonly fetchLocalized = async (path: string, requestOptions?: RequestInit) => {
    return fetch(
      path,
      requestOptions || {
        headers: {
          'Accept-Language': i18next.language
        }
      }
    );
  };
}

export default CmsDealFinderGlobalConfigService;
